import StepItem from "./StepItem";
import Steps from "./Steps";

Steps.Item = StepItem;

export default Steps;
